import React from 'react';
import { Platform } from 'react-native';

export const PlatformWrapper = ({ children, webStyle, mobileStyle }) => {
  const style = Platform.OS === 'web' ? webStyle : mobileStyle;
  return (
    <div style={style}>
      {children}
    </div>
  );
}; 